import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    border-radius: var(--sl-border-radius-medium);
  }

  .modal-content {
    padding: 0;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  .required {
    color: var(--sl-color-danger-600);
  }

  .error-message {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--sl-color-danger-600);
  }

  .help-text {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--sl-color-neutral-500);
  }

  .role-descriptions {
    margin-top: 1.5rem;
    padding: 1rem;
    background: var(--sl-color-neutral-50);
    border-radius: var(--sl-border-radius-small);
    border: 1px solid var(--sl-color-neutral-200);
  }

  .role-descriptions h4 {
    margin: 0 0 0.75rem 0;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  .role-descriptions ul {
    margin: 0;
    padding-left: 1.25rem;
    font-size: 0.75rem;
    color: var(--sl-color-neutral-600);
  }

  .role-descriptions li {
    margin-bottom: 0.25rem;
    line-height: 1.4;
  }

  .role-descriptions strong {
    color: var(--sl-color-neutral-800);
  }

  /* Form validation styles */
  sl-input[invalid] {
    --sl-input-border-color: var(--sl-color-danger-600);
  }

  sl-select[invalid] {
    --sl-select-border-color: var(--sl-color-danger-600);
  }

  /* Dialog customization */
  sl-dialog {
    --width: 500px;
    --height: auto;
  }

  sl-dialog::part(body) {
    padding: 1.5rem;
  }

  .form-footer {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 2rem;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    sl-dialog {
      --width: 90vw;
      --height: 90vh;
    }

    .form-container {
      padding: 0.5rem 0;
    }

    .form-group {
      margin-bottom: 1rem;
    }

    .role-descriptions {
      margin-top: 1rem;
      padding: 0.75rem;
    }
  }

  @media (max-width: 480px) {
    sl-dialog::part(body) {
      padding: 1rem;
    }

    sl-dialog::part(footer) {
      padding: 0.75rem 1rem;
    }

    .role-descriptions ul {
      font-size: 0.7rem;
    }
  }
`;
